module.exports = __webpack_public_path__ + "img/9788901165875.fd8c8d7b.jpg";